module.exports = __webpack_public_path__ + "static/media/GCashxZing@1x.8c18a39e.png";